module.exports = __webpack_public_path__ + "static/img/9.577ad10.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/1/zh/9.png
// module id = TxJF
// module chunks = 0